import { render, staticRenderFns } from "./gameNewRecom.vue?vue&type=template&id=1bd62280&scoped=true&"
import script from "./gameNewRecom.vue?vue&type=script&lang=ts&"
export * from "./gameNewRecom.vue?vue&type=script&lang=ts&"
import style0 from "./gameNewRecom.vue?vue&type=style&index=0&id=1bd62280&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd62280",
  null
  
)

export default component.exports